<template>
  <div>
    <v-btn v-if="canRegister" to="/" class="mr-1" color="primary"
      >REGISTRATI</v-btn
    >

    <v-btn v-if="canLogin" to="/login" class="mr-1" color="primary" outlined
      >ACCEDI</v-btn
    >

    <v-menu
      offset-y
      min-width="200"
      bottom
      v-if="$store.state.isLogged()"
      v-model="profileMenu"
      :close-on-click="closeOnClick"
      :close-on-content-click="closeOnContentClick"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-avatar v-if="hasAvatar && getAvatar" v-bind="attrs" v-on="on">
          <v-img :src="getAvatar" :alt="getUsername" />
        </v-avatar>
        <v-avatar
          v-else-if="getProfileLetters"
          v-bind="attrs"
          v-on="on"
          color="green"
          size="48"
        >
          <span class="white--text headline">{{ getProfileLetters }}</span>
        </v-avatar>
      </template>
      <v-list>
        <v-list-item v-if="isAdmin" to="/backoffice/users">
          <v-list-item-title>Gestione utenti</v-list-item-title>
        </v-list-item>

         <v-list-item v-if="isAdmin" to="/backoffice/sites">
          <v-list-item-title>Gestione siti</v-list-item-title>
        </v-list-item>

        <v-divider v-if="isAdmin"></v-divider>

        <v-list-item to="/profile">
          <v-list-item-title>Profilo</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="$store.state.user && $store.state.user.sites_count" to="/">
          <v-list-item-title>Area personale</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-title>Esci</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import rolesServices from "../services/roles";

export default {
  data: () => ({
    profileMenu: false,
    closeOnClick: true,
    closeOnContentClick: true,
  }),

  mounted() {

  },

  computed: {
    canRegister() {
      return (
        !this.$store.state.isLogged() &&
        !this.$route.query.token &&
        this.$store.state.wizard.selectedStep > 1 &&
        this.$route.fullPath != "/" &&
        this.$route.fullPath != "/register-confirm"
      );
    },

    canLogin() {
      return !this.$store.state.isLogged() && this.$route.fullPath != "/login";
    },

    isAdmin() {
      return rolesServices.isAdmin(this.$store.state);
    },

    isSuperAdmin() {
      return rolesServices.isSuperAdmin(this.$store.state);
    },

    isReview() {
      return rolesServices.isReview(this.$store.state);
    },

    isLoggedIn() {
      return this.$store.state.user ? true : false;
    },

    hasAvatar: function() {
      return this.$store.state.user.avatar ? true : false;
    },

    getAvatar: function() {
      return "data:image/jpeg;base64," + this.$store.state.user.avatar;
    },

    getUsername: function() {
      return this.$store.state.user.first_name;
    },

    getProfileLetters: function() {
      if (
        this.$store.state.user.first_name &&
        this.$store.state.user.last_name
      ) {
        if (
          this.$store.state.user.first_name.length &&
          this.$store.state.user.last_name.length
        ) {
          return (
            this.$store.state.user.first_name.toUpperCase()[0] +
            this.$store.state.user.last_name.toUpperCase()[0]
          );
        }
      }
      return "??";
    },
  },

  methods: {
    logout: function() {
      this.$store
        .dispatch("logout")
        .then(() => {
          if (this.$router.currentRoute.path != "/wizard") this.$router.push("/wizard");
        })
        .catch(() => {
            this.$router.push("/login");
        });
    },
  },
};
</script>
